'use strict';
(function () {
  angular.module('pentaApp').factory('clientCustomInquery.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/clientCustomInquery', null, { queryNoPaginate: { isArray: true, cache: false } });
  }
})();